import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiInbox } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { formatApiError } from '../../utils/formatters';
import './sharing.css';

/**
 * 받은 공유 — 대기 중인 것을 「추가」 하거나 거절한다. 받은 사람이 추가해야 효력이 생긴다(몰래 끼어들지 않게).
 * 대기 중인 것이 없으면 아무것도 그리지 않는다.
 *
 * @param kinds       보일 종류(['conn-use','conn-copy'] / ['dashboard'])
 * @param onAccepted  (결과) => void   추가한 뒤 목록 새로고침 등
 * @param reloadKey   바뀌면 다시 읽는다
 */
export default function IncomingShares({ api, kinds, onAccepted, reloadKey }) {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const load = useCallback(async () => {
    try { setRows((await api.incoming(kinds)).filter(r => r.status === 'pending')); } catch (_e) { setRows([]); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, (kinds || []).join(',')]);
  useEffect(() => { load(); }, [load, reloadKey]);

  if (rows.length === 0) return null;
  const act = async (s, accept) => {
    try {
      const r = accept ? await api.accept(s.id) : await api.decline(s.id);
      if (accept) toast.success(t('common:share.added', { name: s.title || '' }));
      await load();
      if (accept && onAccepted) onAccepted(r, s);
    } catch (err) { toast.error(formatApiError(err, t)); load(); }
  };
  return (
    <div className="share-incoming">
      <div className="share-incoming-head"><FiInbox size={12} /> {t('common:share.incomingTitle', { n: rows.length })}</div>
      {rows.map(s => (
        <div key={s.id} className="share-incoming-row">
          <div className="share-incoming-text">
            <b>{s.title || s.resourceId}</b>
            <span className="share-muted">
              {t('common:share.fromWho', { name: (s.person && s.person.name) || s.fromUsrid })}
              {' · '}{t(`common:share.kind.${s.kind}`)}
              {s.kind === 'conn-use' ? ` · ${s.options && s.options.readOnly === false ? t('common:share.writeAllowed') : t('common:share.readOnly')}` : ''}
            </span>
          </div>
          <button type="button" className="app-btn app-btn-primary" onClick={() => act(s, true)}>{t('common:share.accept')}</button>
          <button type="button" className="app-btn" onClick={() => act(s, false)}>{t('common:share.decline')}</button>
        </div>
      ))}
    </div>
  );
}
